import { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const FloatingActions = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const actions = [
    {
      icon: 'ri-whatsapp-line',
      label: 'WhatsApp',
      color: 'bg-green-500 hover:bg-green-600',
      href: 'https://wa.me/1234567890',
    },
    {
      icon: 'ri-phone-line',
      label: 'Call Us',
      color: 'bg-primary-700 hover:bg-primary-800',
      href: 'tel:+1234567890',
    },
    {
      icon: 'ri-file-text-line',
      label: 'Get Quote',
      color: 'bg-primary-500 hover:bg-primary-600',
      to: '/quote',
    },
  ];

  return (
    <div
      className="fixed bottom-10 right-10 z-40 flex flex-col items-end space-y-3"
      onMouseEnter={() => setIsExpanded(true)}
      onMouseLeave={() => setIsExpanded(false)}
    >
      <AnimatePresence>
        {isExpanded && (
          <>
            {actions.map((action, index) => (
              <motion.div
                key={action.label}
                initial={{ opacity: 0, x: 20, scale: 0.8 }}
                animate={{ opacity: 1, x: 0, scale: 1 }}
                exit={{ opacity: 0, x: 20, scale: 0.8 }}
                transition={{ delay: index * 0.05 }}
                className="flex items-center space-x-3"
              >
                <span className="bg-white px-4 py-2 rounded-lg shadow-lg text-sm font-medium text-gray-900 whitespace-nowrap">
                  {action.label}
                </span>
                {action.to ? (
                  <Link
                    to={action.to}
                    className={`w-14 h-14 flex items-center justify-center ${action.color} text-white rounded-full shadow-lg transition-all duration-300 hover:scale-110 cursor-pointer`}
                  >
                    <i className={`${action.icon} text-2xl`}></i>
                  </Link>
                ) : (
                  <a
                    href={action.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-14 h-14 flex items-center justify-center ${action.color} text-white rounded-full shadow-lg transition-all duration-300 hover:scale-110 cursor-pointer`}
                  >
                    <i className={`${action.icon} text-2xl`}></i>
                  </a>
                )}
              </motion.div>
            ))}
          </>
        )}
      </AnimatePresence>

      {!isExpanded && (
        <motion.div
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-primary-500 to-primary-700 text-white rounded-full shadow-2xl cursor-pointer hover:scale-110 transition-transform duration-300"
        >
          <i className="ri-customer-service-2-line text-3xl"></i>
        </motion.div>
      )}
    </div>
  );
};

export default FloatingActions;
